import React from "react";
const ColoredLabel = ({ label, isBlue = false, isRed = false }) => {
    const style = { color: "black", fontWeight: 400 };
    if (isBlue) {
        style.color = "#00264C";
        style.fontWeight = 600;
    }
    else if (isRed) {
        style.color = "#DA2022";
        style.fontWeight = 600;
    }
    return React.createElement("span", { style: style }, label);
};
export default ColoredLabel;
//# sourceMappingURL=index.js.map